import { render, staticRenderFns } from "./DetailsTextInput.vue?vue&type=template&id=563490dc&scoped=true"
import script from "./DetailsTextInput.vue?vue&type=script&lang=ts"
export * from "./DetailsTextInput.vue?vue&type=script&lang=ts"
import style0 from "./DetailsTextInput.vue?vue&type=style&index=0&id=563490dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563490dc",
  null
  
)

export default component.exports